/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Action/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import CheckIn from './CheckIn/index'
import No from './No/index'
import React from 'react'
import Schedule from './Schedule/index'



/** @type {import('Simple/types.js').View} */
export default function Action({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Agenda/Appointments/Content/Appointment/Action/Action"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let appointmentBookingStateValueData = fromData.useDataFormat({ viewPath,
context: 'appointment_booking',
path: 'state',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: appointmentBookingStateValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CheckIn'}>
<CheckIn
  viewPath={`${viewPath}/CheckIn`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Schedule'}>
<Schedule
  viewPath={`${viewPath}/Schedule`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}